import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Container, Grid, TextField, MenuItem } from "@material-ui/core";
import { GetConsultants, GetConsultantProjects, GetPublicHolidays } from './TimeAction';
import ConsultantProjects from './ConsultantProjects';
import OverLoader from '../../components/common/loader';
import '../../App.css';
import locale from "antd/es/date-picker/locale/de_DE";
import moment from "moment";
import { DatePicker } from "antd";
const dateFormat = 'YYYY';
const currentYear = moment().format(dateFormat);

class TimeRegistration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: this.currentMonthYear('month'),
      year: this.currentMonthYear('year'),
      user_id: JSON.parse(localStorage.getItem("user")).id,
      own_access: false,
      other_access: false
    }
  }

  componentDidMount() {
    const { GetConsultants } = this.props;
    GetConsultants();
    this.searchConsultantProjects()
    this.setUpAccessRightsBits()
  }

  currentMonthYear = (currentMonthYear) => {
    const today = new Date()
    const valueMonthYear = {
      month: today.getMonth() + 1,
      year: today.getFullYear()
    }
    return valueMonthYear[currentMonthYear];
  }

  searchConsultantProjects() {
    const { GetConsultantProjects, GetPublicHolidays } = this.props;
    const { user_id, month, year } = this.state;
    if (!month || !year) return;
    GetConsultantProjects(user_id, month, year)
    GetPublicHolidays(month, year)
  }

  monthHandler = (e) => {
    this.setState({ month: e.target.value }, () => {
      this.searchConsultantProjects()
    })
  }

  yearHandler = (e) => {
    let date = moment(e).format(dateFormat);
    this.setState({ year: date }, () => {
      this.searchConsultantProjects()
    })
  }

  consultantHandler = (e) => {
    this.setState({ user_id: e.target.value }, () => {
      this.setUpAccessRightsBits()
      this.searchConsultantProjects()
    })
  }

  setUpAccessRightsBits = () => {
    if (this.state.user_id === JSON.parse(localStorage.getItem("user")).id) {
      this.setState({ own_access: true, other_access: false })
    } else {
      this.setState({ own_access: false, other_access: true })
    }
  }

  render() {
    const { user_id, month, year } = this.state;
    const { consultant_projects, isloading, public_holidays, consultants_list } = this.props;
    const access_rights = JSON.parse(localStorage.getItem('access_right'))

    return (
      <React.Fragment>
        {isloading && <OverLoader />}
        {Number(access_rights.time_reg_for_own) === 0 && Number(access_rights.time_reg_other_consultants_other) === 0 ?
          <h3>Access Denied</h3>
          :
          <Container maxWidth="xl">
            <Grid container spacing={3} className="mainBlock">
              <Grid item xs={12}>
                <div className="rightBlock liproCard zoom-min">
                  <Grid container spacing={1} className="fullWidth">
                    <Grid container item xs={5} spacing={1} style={{ height: '115px' }}>
                      <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                        Berater
                                        </Grid>
                      <Grid item xs={8}>
                        <TextField
                          select
                          variant="outlined"
                          className="select-box"
                          size="small"
                          fullWidth
                          value={user_id}
                          onChange={(e) => this.consultantHandler(e)}>
                          {
                            consultants_list && consultants_list.map(consultant => (
                              <MenuItem key={consultant.id}
                                value={consultant.id}>{consultant.full_name}</MenuItem>
                            ))
                          }
                        </TextField>
                      </Grid>
                      <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                        Monat
                                        </Grid>
                      <Grid item xs={4}>
                        <TextField
                          select
                          variant="outlined"
                          className="select-box"
                          size="small"
                          fullWidth
                          value={month}
                          onChange={(e) => this.monthHandler(e)}>
                          <MenuItem value={1}>Januar</MenuItem>
                          <MenuItem value={2}>Februar</MenuItem>
                          <MenuItem value={3}>März</MenuItem>
                          <MenuItem value={4}>April</MenuItem>
                          <MenuItem value={5}>Mai</MenuItem>
                          <MenuItem value={6}>Juni</MenuItem>
                          <MenuItem value={7}>Juli</MenuItem>
                          <MenuItem value={8}>August</MenuItem>
                          <MenuItem value={9}>September</MenuItem>
                          <MenuItem value={10}>Oktober</MenuItem>
                          <MenuItem value={11}>November</MenuItem>
                          <MenuItem value={12}>Dezember</MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item xs={4}>
                        <DatePicker
                          locale={locale}
                          picker="year"
                          fullWidth
                          required
                          size="small"
                          value={year === '' ? this.setState({ year: currentYear }) : moment(year, dateFormat)}
                          format={dateFormat}
                          placeholder="YYYY"
                          allowClear={false}
                          bordered={false}
                          style={{ width: '100%' }}
                          onChange={(e) => this.yearHandler(e)}
                        />
                      </Grid>
                    </Grid>
                    <ConsultantProjects consultant_projects={consultant_projects}
                      public_holidays={public_holidays}
                      month={this.state.month} year={this.state.year}
                      own_access={this.state.own_access} other_access={this.state.other_access}
                    />
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </Container>}
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ timeRegistration }) => {
  return {
    isloading: timeRegistration.loading,
    consultants_list: timeRegistration.consultants_list,
    consultant_projects: timeRegistration.consultant_projects,
    public_holidays: timeRegistration.public_holidays
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetConsultants: () => dispatch(GetConsultants()),
    GetConsultantProjects: (userId, month, year) => dispatch(GetConsultantProjects(userId, month, year)),
    GetPublicHolidays: (month, year) => dispatch(GetPublicHolidays(month, year))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(TimeRegistration);